import React from 'react'
import { CollapickForm } from '@collapick/form';
import { Typography, Grid, Box, Button } from '@material-ui/core'
import { useTranslation } from 'react-i18next';
import useProjectSizeSchema from '../../FormSchemas/useProjectSizeSchema';

const ProjectSizeForm = (props) => {
    const { initialValues, title, onSave, onCancel } = props
    const { t } = useTranslation()
    const { projectSizeSchema } = useProjectSizeSchema();

    return (
        <>
            <Grid container justify="center" >
                <Box my={2} >
                    <Typography variant="h2">{title}</Typography>
                </Box>
            </Grid>
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <CollapickForm
                        formSchema={projectSizeSchema}
                        onFormSubmit={onSave}
                        resetFormAfterSubmit={true}
                        initialValues={initialValues}
                        renderSubmitButton={() =>
                            <Button
                                variant="contained"
                                type="submit"
                                color="primary"
                                fullWidth>
                                {t('save')}
                            </Button>}
                        showInvalidSaveButton={true}
                        invalidSubmitText={t("cancel")}
                        onInvalidSubmit={onCancel}
                    />
                </Grid>
            </Grid>
        </>
    )
}
export default ProjectSizeForm